import { jsx as n } from "react/jsx-runtime";
import { c as l } from "../index-rKuIKazb.js";
import { useTheme as _ } from "../ThemeProvider/index.js";
import '../assets/index17.css';const d = "_layout_1kgqp_2", u = "_dark_1kgqp_14", e = {
  layout: d,
  "--theme-manatee": "_--theme-manatee_1kgqp_9",
  dark: u
}, k = (t) => {
  const { children: a, className: s, id: o, theme: m = "default" } = t, r = _(), c = l(
    e[r],
    e.layout,
    e[`--theme-${m}`],
    s
  );
  return /* @__PURE__ */ n("div", { id: o, className: c, children: a });
};
export {
  k as default
};
